<script lang="ts">
  import type { Snippet } from 'svelte'
  import { I18n, setI18n } from '../i18n'
  import type { Locale } from '../translations'

  let { locale, children }: { locale: Locale; children: Snippet } = $props()

  setI18n(new I18n(() => locale))
</script>

{@render children()}
